export default {"src":"/_next/static/media/spank.3a37cc51.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};